export const convertToFormattedNumber = (num: string): string => {
  // Convert to comma number format, if decimal is present include 2 decimal places
  if (num.includes(".")) {
    const [wholeNum, decimal] = num.split(".");
    return parseInt(wholeNum).toLocaleString() + "." + decimal;
  } else {
    return parseInt(num).toLocaleString();
  }
};
